import cn from 'classnames';
import styles from '../checkboxList/styles.module.scss';
import Checkbox from '../../../ui/checkbox';

function NestedList({ childs, handleChange }: any) {
  return (
    <div className={styles.container}>
      {childs?.map((child: any, i: number) => (
        <div key={i} className={styles.filterSectionSettingContainer}>
          <Checkbox
            checked={child.selected}
            onChanges={() => {
              handleChange(childs, child);
            }}
          >
            <p className={cn(styles.filterSectionSetting, styles.category)}>
              {child.name}
            </p>
          </Checkbox>
        </div>
      ))}
    </div>
  );
}

export default NestedList;
